import React from 'react';
import SelectSchool from './SelectSchool';
import SelectClassroom from './SelectClassroom';
import './HeaderUserPane.scss';
import AppSwitcher from '../Global/AppSwitcher/AppSwitcher';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectUserData } from '@/store/slices/UserDataSlice';

const HeaderUserPane = () => {
  const { t } = useTranslation(['navigation']);
  const userData = useSelector(selectUserData);
  let entitlement: 'lectura' | 'math' | 'lectura_math' | null = null;

  if (userData) {
    const { math, lectura } = userData.entitlements.subscriptions;
    if (math && lectura) {
      entitlement = 'lectura_math';
    } else if (math) {
      entitlement = 'math';
    } else if (lectura) {
      entitlement = 'lectura';
    }
  }

  return (
    <div className="header-user-pane-wrapper d-flex gap-3 align-items-center justify-content-center">
      <SelectSchool />
      <SelectClassroom />
      {entitlement && (
        <AppSwitcher entitlement={entitlement} placement={'bottom'} />
      )}
    </div>
  );
};

export default HeaderUserPane;
